import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ArrecadacaoInfo.module.scss';

export default function ArrecadacaoInfo() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const acessarSistema = () => {
    globalThis.location.href = `${globalThis.location.origin}/arrecadacao`;
  };

  return (
    <div className={styles.page}>
      <div className={styles.topBar}>
        <button
          className={styles.back}
          onClick={() => navigate('/')}
          type='button'
        >
          <i className={'fas fa-arrow-left'} aria-hidden='true' />
          Voltar
        </button>
      </div>

      <div className={styles.hero}>
        <div className={styles.iconWrap}>
          <i className={'fas fa-money-bill-wave'} aria-hidden='true' />
        </div>
        <div className={styles.heroText}>
          <h1 className={styles.title}>Arrecadação CFEM</h1>
          <p className={styles.subtitle}>
            Compensação Financeira pela Exploração Mineral
          </p>
        </div>
      </div>

      <div className={styles.content}>
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>O que é?</h2>
          <p className={styles.text}>
            A arrecadação da CFEM é o processo pelo qual o empreendedor efetua o
            pagamento da Compensação Financeira devida ao Estado pela exploração
            de recursos minerais. O valor é calculado com base nas receitas de
            venda declaradas na DIEF-CFEM e deve ser pago mensalmente.
          </p>
        </section>

        <section className={`${styles.section} ${styles.highlightSection}`}>
          <div className={styles.highlightIcon}>
            <i className={'fas fa-calendar-alt'} aria-hidden='true' />
          </div>
          <div>
            <h2 className={styles.sectionTitle}>Prazo de pagamento</h2>
            <p className={styles.text}>
              A guia de recolhimento deve ser gerada e paga até o{' '}
              <strong>último dia do mês subsequente</strong> ao período de
              referência. O pagamento fora do prazo está sujeito a acréscimos
              moratórios previstos em lei.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Formas de Pagamento</h2>
          <div className={styles.paymentGrid}>
            <div className={styles.paymentCard}>
              <div className={styles.paymentIcon}>
                <i className={'fas fa-qrcode'} aria-hidden='true' />
              </div>
              <div>
                <strong className={styles.paymentTitle}>Pix</strong>
                <p className={styles.paymentDesc}>
                  Pagamento instantâneo disponível 24h. Utilize o QR Code ou a
                  chave Pix gerada na guia de recolhimento para efetuar a
                  transferência.
                </p>
              </div>
            </div>

            <div className={styles.paymentCard}>
              <div className={styles.paymentIcon}>
                <i className={'fas fa-credit-card'} aria-hidden='true' />
              </div>
              <div>
                <strong className={styles.paymentTitle}>
                  Cartão de Débito
                </strong>
                <p className={styles.paymentDesc}>
                  O valor é debitado diretamente da conta corrente do titular no
                  momento do pagamento.
                </p>
              </div>
            </div>

            <div className={styles.paymentCard}>
              <div className={styles.paymentIcon}>
                <i className={'fas fa-credit-card'} aria-hidden='true' />
              </div>
              <div>
                <strong className={styles.paymentTitle}>
                  Cartão de Crédito
                </strong>
                <p className={styles.paymentDesc}>
                  Pagamento à vista ou parcelado conforme as condições do cartão
                  e da operadora.
                </p>
              </div>
            </div>

            <div className={styles.paymentCard}>
              <div className={styles.paymentIcon}>
                <i className={'fas fa-barcode'} aria-hidden='true' />
              </div>
              <div>
                <strong className={styles.paymentTitle}>Boleto</strong>
                <p className={styles.paymentDesc}>
                  Emita a guia com código de barras e realize o pagamento em
                  banco, lotérica ou aplicativo bancário até a data de
                  vencimento.
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className={styles.ctaWrap}>
          <button
            className={styles.ctaBtn}
            onClick={acessarSistema}
            type='button'
          >
            Acessar Arrecadação CFEM
            <i className={'fas fa-external-link-alt'} aria-hidden='true' />
          </button>
        </div>
      </div>
    </div>
  );
}
